import React, { useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { isUpiValid } from '../helper';
import styles from '../styles.module.css';

interface UpiFormProps {
  upiRegex?: string;
  isSubmitting?: boolean;
  onSubmit: (upiId: string) => void;
}

const UpiForm: React.FC<UpiFormProps> = ({
  upiRegex,
  isSubmitting,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const [upiId, setUpiId] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (isSubmitting) return;

    if (!isUpiValid(upiId, upiRegex)) {
      setError(t('invalidUpiError'));
      return;
    }
    setError('');
    onSubmit(upiId);
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit} noValidate>
      <div className={styles.field}>
        <label className="fontSizeSm12 fontColor666" htmlFor="upi-id">
          {t('upiIdLabel')}
        </label>
        <input
          id="upi-id"
          className={clsx(styles.input, error && styles.inputError)}
          type="text"
          autoComplete="off"
          autoCapitalize="none"
          spellCheck={false}
          placeholder={t('upiIdPlaceholder')}
          value={upiId}
          onChange={(e) => {
            setUpiId(e.target.value);
            if (error) setError('');
          }}
          aria-invalid={Boolean(error)}
          aria-describedby={error ? 'upi-id-error' : undefined}
        />
        {error && (
          <p
            id="upi-id-error"
            className={clsx(styles.fieldError, 'fontSizeSm12')}
            role="alert"
          >
            {error}
          </p>
        )}
      </div>

      <button
        type="submit"
        className="btn primaryBtn"
        disabled={!upiId.trim() || isSubmitting}
      >
        {isSubmitting ? t('pleaseWait') : t('continue')}
      </button>
    </form>
  );
};

export default UpiForm;
